import { IUserValidationDetailedError } from '../api-client/models/user-validation-detailed-error';

export function friendlyUserValidationError(value: any): string {

    if (!value) {

        return '';
    }

    const error = value as IUserValidationDetailedError;

    let friendlyType = '';

    switch (error.type) {

        case 'AccessDenied':
            friendlyType = 'Behörighet saknas';
            break;
        case 'AuthCodeEnvelopeAlreadyMapped':
            friendlyType = 'Kodkuvertet är redan kopplad';
            break;
        case 'AuthCodeEnvelopeNotFound':
            friendlyType = 'Kodkuvertert existerar inte';
            break;
        case 'AuthCodeEnvelopeInvalid':
            friendlyType = 'ID-nummer för kodkuvertert är ogiltigt';
            break;
        case 'DuplicatedEnvelopeIdentifier':
            friendlyType = 'Duplicerade identiferare för kodkuvertert';
            break;
        case 'DuplicatedId':
            friendlyType = 'Duplicerade ID-nummer'; // Ska hänta om inte kollision vid hashning sker
            break;
        case 'DuplicatedIdentifier':
            friendlyType = 'Duplicerade identifierare';
            break;
        case 'DuplicatedMembershipNumber':
            friendlyType = 'Duplicerade medlemsnummer';
            break;
        case 'InvalidBankIdProvider':
            friendlyType = 'Ogiltigt personnummer för BankID';
            break;
        case 'InvalidEmail':
            friendlyType = 'Ogiltig e-postadress';
            break;
        case 'InvalidPersonalIdentityNumber':
            friendlyType = 'Ogiltigt personnummer';
            break;
        case 'InvalidOrganizationNumber':
            friendlyType = 'Ogiltigt organisationsnummer';
            break;
        case 'InvalidPhone':
            friendlyType = 'Ogiltigt telefonnummer';
            break;
        case 'InvalidZipCode':
            friendlyType = 'Ogiltigt postnummer';
            break;
        case 'OrganizationalUnitPathIsNotAllowed':
            friendlyType = 'Behörighet till organisationstillhörighet saknas';
            break;
        case 'OrganizationalUnitPathsIsRequired':
            friendlyType = 'Organisationstillhörighet måste anges';
            break;
        case 'RequiredIdentifier':
            friendlyType = 'Identifierare saknas för en eller flera användare.';
            break;
        case 'Weight':
            friendlyType = 'Ogiltig vikt';
            break;
        case 'InvalidIdentifierPrefix':
            friendlyType = 'Ogiltig identifierare, identifieraren får inte börja med ev-';
            break;
    }

    if (error.originalValues.length <= 0) {

        return friendlyType;
    }

    const originalValues = error.originalValues.join(', ');

    return `${friendlyType}: ${originalValues}`;
}
